import Vue from 'vue'
import Reviews from './Reviews.vue'
import HoursIndicator from './HoursIndicator.vue'

Array.from(document.querySelectorAll('[data-app="reviews"]')).forEach(el => {
    console.log(el)
    const app = new Vue({
        el,
        components: { Reviews },
        template: `<Reviews :uberall-id="${el.getAttribute('data-uberall-id')}" />`,
    })
})

Array.from(document.querySelectorAll('[data-app="hours-indicator"]')).forEach(el => {
    console.log(el)
    const app = new Vue({
        el,
        components: { HoursIndicator },
        template: `<HoursIndicator :uberall-id="${el.getAttribute('data-uberall-id')}" />`,
    })
})